export * from './fake-backend';
export * from './auth-header';
export * from './common';

export const accessToken  = JSON.parse(localStorage.getItem('access_token'));